import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from "reselect";
import { changeLayoutMode } from "../../../slices/thunks";
import "./AboutUs.scss";
import Navbar from "./navbar";
import Footer from "./footer";
import { Container, Row, Col, Card } from "react-bootstrap";
import { motion } from "framer-motion";
import "./AboutUs/AboutUs_MIssion.scss";
import { CardBody } from "reactstrap";
import { Link } from "feather-icons-react/build/IconComponents";

const industryPricing = {
    manufacturing: [
        { id: 1, type: "Infinity Fleet", rate: 25, purpose: "For Manufacturing" },
        { id: 2, type: "Infinity ERP", rate: 35, purpose: "For Manufacturing" },
        { id: 3, type: "Infinity-X", rate: 45, purpose: "For Manufacturing" },
    ],
    retail: [
        { id: 1, type: "Infinity Fleet", rate: 20, purpose: "For Retail" },
        { id: 2, type: "Infinity ERP", rate: 30, purpose: "For Retail" },
        { id: 3, type: "Infinity-X", rate: 40, purpose: "For Retail" },
    ],
    healthcare: [
        { id: 1, type: "Infinity Fleet", rate: 22, purpose: "For Healthcare" },
        { id: 2, type: "Infinity ERP", rate: 32, purpose: "For Healthcare" },
        { id: 3, type: "Infinity-X", rate: 42, purpose: "For Healthcare" },
    ],
    steelIndustry: [
        { id: 1, type: "Infinity Fleet", rate: 28, purpose: "For Steel Industry" },
        { id: 2, type: "Infinity ERP", rate: 38, purpose: "For Steel Industry" },
        { id: 3, type: "Infinity-X", rate: 48, purpose: "For Steel Industry" },
    ],
    restaurants: [
        { id: 1, type: "Infinity Fleet", rate: 18, purpose: "For Restaurants" },
        { id: 2, type: "Infinity ERP", rate: 28, purpose: "For Restaurants" },
        { id: 3, type: "Infinity-X", rate: 38, purpose: "For Restaurants" },
    ],
    educationalInstitutions: [
        { id: 1, type: "Infinity Fleet", rate: 24, purpose: "For Educational Institutions" },
        { id: 2, type: "Infinity ERP", rate: 34, purpose: "For Educational Institutions" },
        { id: 3, type: "Infinity-X", rate: 44, purpose: "For Educational Institutions" },
    ],
    supplierManagement: [
        { id: 1, type: "Infinity Fleet", rate: 26, purpose: "For Supplier Management" },
        { id: 2, type: "Infinity ERP", rate: 36, purpose: "For Supplier Management" },
        { id: 3, type: "Infinity-X", rate: 46, purpose: "For Supplier Management" },
    ],
    hospitalManagement: [
        { id: 1, type: "Infinity Fleet", rate: 23, purpose: "For Hospital Management" },
        { id: 2, type: "Infinity ERP", rate: 33, purpose: "For Hospital Management" },
        { id: 3, type: "Infinity-X", rate: 43, purpose: "For Hospital Management" },
    ],
    mallAndTheaterManagement: [
        { id: 1, type: "Infinity Fleet", rate: 27, purpose: "For Mall & Theater Management" },
        { id: 2, type: "Infinity ERP", rate: 37, purpose: "For Mall & Theater Management" },
        { id: 3, type: "Infinity-X", rate: 47, purpose: "For Mall & Theater Management" },
    ],
    solventPlantManagement: [
        { id: 1, type: "Infinity Fleet", rate: 29, purpose: "For Solvent Plant Management" },
        { id: 2, type: "Infinity ERP", rate: 39, purpose: "For Solvent Plant Management" },
        { id: 3, type: "Infinity-X", rate: 49, purpose: "For Solvent Plant Management" },
    ],
};

const Pricing = () => {
    const dispatch = useDispatch();
    const [selectedIndustry, setSelectedIndustry] = useState("manufacturing");
    const [pricing, setPricing] = useState(industryPricing.manufacturing);

    const selectLayoutState = (state) => state.Layout;
    const selectLayoutProperties = createSelector(
        selectLayoutState,
        (layout) => ({
            layoutModeType: layout.layoutModeType,
        })
    );
    const { layoutModeType } = useSelector(selectLayoutProperties);


    const onChangeLayoutMode = (value) => {
        if (changeLayoutMode) {
          dispatch(changeLayoutMode(value));
        }
      };
      
    useEffect(() => {
        if (layoutModeType) {
            window.dispatchEvent(new Event("resize"));
            dispatch(changeLayoutMode(layoutModeType));
        }
    }, [layoutModeType, dispatch]);

    useEffect(() => {
        setPricing(industryPricing[selectedIndustry]);
    }, [selectedIndustry]);

    const handleIndustryChange = (e) => {
        setSelectedIndustry(e.target.value);
    };

    return (
        <div style={{ overflow: "hidden"}}>
            <Navbar onChangeLayoutMode={onChangeLayoutMode} layoutModeType={layoutModeType} />
            <motion.section
                className="ezy__howitworks3 py-5"
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                transition={{ duration: 0.5 }}
                viewport={{ once: true }}
            >
                <Container>
                    <Row className="justify-content-center text-center mb-5 mt-5">
                        <Col xl={8} lg={10}>
                            <h1 className="ezy__howitworks3-heading text-primary display-4 mb-3">
                                Pricing
                            </h1>
                            <p className="ezy__howitworks3-sub-heading lead text-muted">
                                Unlock the full potential of your business with our cutting-edge
                                automation solutions. Seamless integrations, unparalleled support, and customizable options - we've got you covered.
                            </p>
                            <select
                                className="form-select mt-3"
                                value={selectedIndustry}
                                onChange={handleIndustryChange}
                            >
                                <option value="" disabled>
                                    -- Select Industry --
                                </option>
                                <option value="manufacturing">Manufacturing</option>
                                <option value="retail">Retail</option>
                                <option value="healthcare">Healthcare</option>
                                <option value="steelIndustry">Steel Industry</option>
                                <option value="restaurants">Restaurants</option>
                                <option value="educationalInstitutions">Educational Institutions</option>
                                <option value="supplierManagement">Supplier Management</option>
                                <option value="hospitalManagement">Hospital Management</option>
                                <option value="mallAndTheaterManagement">Mall & Theater Management</option>
                                <option value="solventPlantManagement">Solvent Plant Management</option>
                            </select>

                        </Col>
                    </Row>
                    <Row className="justify-content-center">
                        <Col xl={9}>
                            <Row>
                                {pricing.map((price, key) => (
                                    <Col lg={4} key={key}>
                                        <Card className="pricing-box ribbon-box right" style={{ backgroundColor: "#ffffff", borderRadius: "10px" }}>
                                            <CardBody className="p-4 m-2">
                                                <div className="d-flex align-items-center">
                                                    <div className="flex-grow-1">
                                                        <h5 className="mb-1 fw-semibold">{price.type}</h5>
                                                        <p className="text-muted mb-0">{price.purpose}</p>
                                                    </div>
                                                </div>
                                                <div className="pt-4">
                                                    <h2>
                                                        <sup>
                                                            <small>$ </small>
                                                        </sup>
                                                        {price.rate}
                                                        <span className="fs-13 text-muted">/Month</span>
                                                    </h2>
                                                </div>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                ))}
                            </Row>
                        </Col>
                    </Row>
                </Container>
            </motion.section>
            <Footer />
        </div>
    );
};

export default Pricing;
